
















import { Component, Mixins, Prop, Emit } from "vue-property-decorator";
import { IClaioImageSource } from "../../../../../../domain/claio";
import { Size } from "../../../../../../domain/drawing";
import { BrowserKinds, BrowserUtility } from "../../../../../../utilities";
import { IImageDragParameter } from "../../../../../dragging";

@Component({
  components: {
  }
})
export default class ClaioImagePreview extends Mixins() {
  @Prop()
  src: IClaioImageSource;

  @Prop()
  isFitted: boolean;

  $refs!: {
    container: HTMLDivElement,
  };

  get imageSource(): string {
    if (!this.src) { return null; }
    
    const shouldResizeFitImageAutomatically = this.$configuration.behavior.document.editor.contents.claio.preview.shouldResizeFitImage && (BrowserUtility.getBrowserKind() === BrowserKinds.InternetExplorer);
    return (shouldResizeFitImageAutomatically && this.isFitted)
      ? this.src.getResizedOriginalSource(new Size(this.$refs.container.clientWidth, this.$refs.container.clientHeight))
      : this.src.originalSource;
  }

  onDragStart(event: DragEvent): void {
    const data: IImageDragParameter = {
      isClaioImage: true,
      claioImageDragParameter: {
        patientId: this.src.patientId,
        claioImageId: this.src.claioImageKey,
        isVisibleLayer: !!this.src.isVisibleLayer,
        isMovie: !!this.src.isMovie,
        isSecret: !!this.src.isSecret,
        imageDepartmentId: this.src.departmentId,
      },
    };
    const text = JSON.stringify(data);
    // 第一引数(format)が"text"でないとIEでエラーになる。
    event.dataTransfer.setData("text", text);
  }

  onDoubleClicked(): void {
    this.doubleClick(this.src);
  }

  @Emit()
  doubleClick(src: IClaioImageSource): void {}

  @Emit()
  imageLoaded(): void {}
}
